import { CallNotificationModal } from './CallNotificationModal';

interface PanicDialogProps {
  isOpen: boolean;
  eventId?: string;
  natureOfCall?: string;
  callLocation?: string;
  onViewCall: () => void;
  onDismiss: () => void;
}

export function PanicDialog({
  isOpen,
  eventId,
  natureOfCall,
  callLocation,
  onViewCall,
  onDismiss,
}: PanicDialogProps) {
  return (
    <CallNotificationModal
      open={isOpen}
      title="PANIC CALL"
      eventId={eventId}
      natureOfCall={natureOfCall}
      location={callLocation}
      variant="panic"
      onViewCall={onViewCall}
      onDismiss={onDismiss}
    />
  );
}

(window as any).PanicDialogReact = PanicDialog;
